var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable i18next/no-literal-string -- Dev tools don't use translations */
import { useCallback, useState } from 'react';
import { Box, Button, Typography } from '@lucidlink/uicore';
import { createEventTracingJsonFilename, downloadWithFilePicker, MimeType, } from '../services';
export const EventTracing = ({ filespace }) => {
    _react_refresh_temp_2();
    const [isTracing, setIsTracing] = useState(() => filespace.client.isTracing());
    const startTrace = useCallback(() => {
        setIsTracing(true);
        filespace.client.recordTrace();
    }, [filespace]);
    const downloadTrace = useCallback(() => {
        setIsTracing(false);
        downloadWithFilePicker(createEventTracingJsonFilename(filespace.data), MimeType.Json, filespace.client.stopTrace());
    }, [filespace]);
    const cancelTrace = useCallback(() => {
        setIsTracing(false);
        filespace.client.stopTrace();
    }, [filespace]);
    return (_jsxs(Box, { align: "center", gap: "sm", children: [_jsx(Typography, { color: !isTracing ? 'default' : 'positive', kind: "h5", children: "Event tracing:" }), !isTracing ? (_jsx(Button, { "data-testid": "start-trace", kind: "secondary", onClick: startTrace, children: "Trace" })) : (_jsxs(_Fragment, { children: [_jsx(Button, { "data-testid": "download-trace", kind: "secondary", onClick: downloadTrace, children: "Download" }), _jsx(Button, { "data-testid": "cancel-trace", kind: "secondary", onClick: cancelTrace, children: "Cancel" })] }))] }));
};
_react_refresh_temp_1 = EventTracing;
$RefreshReg$(_react_refresh_temp_1, "EventTracing");
_react_refresh_temp_2(EventTracing, "hJ36+RMH3T+vZPGwTkFqHjG+cfU=");
